const geocoder = new google.maps.Geocoder();

function setGeocodeLocation(inputID, latLng) {
	geocoder.geocode({ 'location': latLng }, function (results, status) {
    if (status === 'OK' && results.length > 0) {
      var element = document.getElementById(inputID);
      element.value = results[0].formatted_address;
      element.dispatchEvent(new Event('selected-map-direction'));
    }
  });
}

// 'options' must be an Object with the same 'config' format
export function initAutocompleteGmaps(inputID, options = null) {
  let config = {
    mapId: null,
    types: { types: ['geocode'] },
    mapPosition: { lat: -28.3857016, lng: -73.6594274 },
    mapZoom: 2
  };

  if (options !== null && typeof options === 'object') {
    Object.assign(config, options);
  }

  const autocompleteAddress = new google.maps.places.Autocomplete(
    document.getElementById(inputID),
    config.types
  );

  if (config.mapId !== null && typeof config.mapId === 'string') {
    const map = new google.maps.Map(
      document.getElementById(config.mapId),
      {
        zoom: config.mapZoom,
        center: new google.maps.LatLng(config.mapPosition.lat, config.mapPosition.lng),
        mapTypeId: google.maps.MapTypeId.ROADMAP
      }
    );

    const marker = new google.maps.Marker({
      map: map,
      draggable: true
    });

    google.maps.event.addListener(marker, 'dragend', function () {
      setGeocodeLocation(inputID, marker.getPosition());
    });

    google.maps.event.addListener(map, 'click', function (event) {
      marker.setPosition(event.latLng);
      setGeocodeLocation(inputID, event.latLng);
    });

    autocompleteAddress.addListener('place_changed', function () {
      const geometry = autocompleteAddress.getPlace().geometry;

      map.fitBounds(geometry.viewport);
      marker.setPosition(geometry.location);
    });
  }

  return autocompleteAddress;
}